import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Link, Navigate } from "react-router-dom";

import Modal from "react-modal";

import { SubmitSpinningButton } from "../../../Component/SubmitSpinningButton";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import "./Style.css";

if (process.env.NODE_ENV !== "test") Modal.setAppElement("#root");

class NewSubject extends Component<any, any> {
    titleRef: React.RefObject<HTMLInputElement>;
    descriptionRef: React.RefObject<HTMLTextAreaElement>;

    constructor(props: any) {
        super(props);

        this.state = {
            isPublic: false,
            subtitle: "subtitle",
            titleError: "",
            routeToNewSubject: undefined
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.togglePublic = this.togglePublic.bind(this);

        this.titleRef = React.createRef();
        this.descriptionRef = React.createRef();
    }

    handleSubmit(ev: any) {
        ev.preventDefault();

        const title: string = this.titleRef.current!.value;
        const description: string = this.descriptionRef.current!.value;
        const isPublic: boolean = this.state.isPublic;
        const types: Array<string> = [];

        this.props.handleSubmit(title, description, types, isPublic);
    }

    togglePublic() {
        this.setState({
            isPublic: !this.state.isPublic
        });
    }

    render() {
        var alert = (<div></div>);
        if (this.props.showError) {
            alert = (
                <Alert severity="warning">
                    <AlertTitle>{this.props.errorTitle}</AlertTitle>
                    {this.props.errorMessage}
                </Alert>
            );
        }
        return (
            <div className="NewSubjectModal">
                <header className="new-subject-header">
                    <p className="new-subject-eyebrow">New study set</p>
                    <h2>Create a subject</h2>
                    <p>
                        Define a subject that you can study—or share with other
                        learners when it is ready.
                    </p>
                </header>

                <form id="new-subject-form" onSubmit={this.handleSubmit} noValidate>
                    <div className="form-group">
                        <div>
                            <label htmlFor="title">Subject name</label>
                            <input
                                className="form-control"
                                ref={this.titleRef}
                                id="title"
                                placeholder="e.g. Modern architecture"
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <div>
                            <label htmlFor="description">Description</label>
                            <textarea
                                className="form-control"
                                ref={this.descriptionRef}
                                id="description"
                                placeholder="What belongs in this subject? Include a course or test name if it helps."
                                rows={4}
                            />
                        </div>
                    </div>
                    <div className="form-group new-subject-visibility">
                        <div>
                            <label className="new-subject-checkbox">
                                <input
                                    type="checkbox"
                                    checked={this.state.isPublic}
                                    onChange={() => this.togglePublic()}
                                    id="is-public"
                                />
                                <span>Make this subject public</span>
                            </label>
                            <p className="new-subject-help">
                                Public subjects are visible to other learners
                                and cannot later be made private.
                            </p>
                        </div>
                    </div>
                    {alert}
                    <div className="new-subject-actions">
                        <SubmitSpinningButton
                            showSpinner={this.props.submitSpinner}
                            text="Create subject"
                        />
                    </div>
                </form>
            </div>
        );
    }
}

export { NewSubject };
